import { ChangeEvent, FC, InputHTMLAttributes, Ref } from 'react';
import clsx from 'clsx';
import { Box } from '../Box';

import styles from './index.module.css';

interface ToggleCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  checked?: boolean;
  inputRef?: Ref<HTMLInputElement>;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const ToggleCheckbox: FC<ToggleCheckboxProps> = ({
  className = '',
  checked = false,
  inputRef = null,
  disabled = false,
  onChange = () => {},
  ...props
}) => {
  const classes = clsx(
    styles.wrapper,
    styles.toggle,
    className,
    disabled && styles.disabled,
    checked && styles.checked
  );

  return (
    <Box data-role="toggle-checkbox" component="label" className={classes}>
      <input
        data-role="toggle-checkbox-input"
        type="checkbox"
        ref={inputRef}
        className={styles.checkbox}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...props}
      />
    </Box>
  );
};
